import { List, RemovedItem, Create, Edit, Barcode } from "../Components/index.js";

export default [
    {
        path: "/store/inventory/item",
        component: List,
        name: "store.inventory.item",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/item-removed",
        component: RemovedItem,
        name: "store.inventory.item.removed",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/barcode/show",
        component: Barcode,
        name: "store.inventory.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/item/create",
        component: Create,
        name: "store.inventory.item.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/inventory/item/:id/edit",
        component: Edit,
        name: "store.inventory.item.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
